<template>
    <div>
        <transition name="fade">
            <div
                v-show="isExpanded"
                class="background-darken"
                @click.stop="isExpanded = false" />
        </transition>
        <div
            class="mobile-footer box"
            :class="{'expanded': isExpanded}">
            <div
                class="stay-top-row d-flex align-items-center"
                :class="{pointer: chargeable}"
                @click="isExpanded = !isExpanded && chargeable">
                <AnbieterLogo class="logo-mobile" />
                <EventTitleAndDate
                    :is-expanded="isExpanded"
                    size="sm"
                    class="ml-2" />
                <font-awesome-icon
                    v-if="chargeable"
                    icon="chevron-up"
                    class="chevron ml-auto" />
            </div>
            <div
                v-if="chargeable"
                class="invoice-row flex-grow-1 h-100 d-flex align-items-end">
                <div
                    class="overflow-auto flex-grow-1"
                    style="max-height: 100%;">
                    <transition name="fade-invoice">
                        <InvoicePreview
                            v-show="isExpanded"
                            :hide-total="true" />
                    </transition>
                </div>
            </div>
            <div
                v-if="chargeable"
                class="stay-bottom-row d-flex align-items-center justify-content-end">
                <span class="total">
                    <transition name="fade">
                        <span
                            v-show="isExpanded"
                            class="mr-3">{{ $t('eventRegistration.invoicePreview.total') }}:</span>
                    </transition>
                    <TotalPrice />
                </span>
            </div>
            <div class="stay-bottom-row-background" />
        </div>
    </div>
</template>

<script>
import AnbieterLogo from "@/components/layouts/eventRegistration/AnbieterLogo";
import EventTitleAndDate from "@/components/layouts/eventRegistration/EventTitleAndDate";
import InvoicePreview from "@/components/pages/registration/InvoicePreview";
import TotalPrice from "@/components/layouts/eventRegistration/TotalPrice";
import registrationPriceMixin from "@/mixins/registration/registrationPriceMixin";

export default {
    name: "MobileFooter",
    components: {TotalPrice, InvoicePreview, EventTitleAndDate, AnbieterLogo},
    mixins: [registrationPriceMixin],
    data() {
        return {
            isExpanded: false
        }
    }
}
</script>

<style lang="scss" scoped>
@use "sass:map";

.box {
    box-shadow: $box-shadow;
    background: $white;
}

.mobile-footer {
    position: fixed;
    overflow: hidden;
    z-index: 2;
    left: 0;
    right: 0;
    bottom: 0;
    height: $registration-mobile-footer-height-closed;
    transition: height $registration-transition-duration $registration-timing-function-half;

    .stay-top-row {
        height: $registration-mobile-footer-height-closed;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        margin: 0 map.get($spacers, 3) 0 map.get($spacers, 2);
        z-index: 3;

        .chevron {
            transition: transform $registration-transition-duration $registration-timing-function;
        }
    }

    .invoice-row {
        padding-top: calc(#{$registration-mobile-footer-height-closed} + #{map.get($spacers, 2)});
        padding-bottom: $registration-mobile-footer-stay-bottom-height;
        margin-right: map.get($spacers, 4);
        margin-left: map.get($spacers, 4);

        .fade-invoice-enter-active {
            transition: opacity .5s ease .2s;
        }

        .fade-invoice-leave-active {
            transition: opacity .3s;
        }

        .fade-invoice-enter, .fade-invoice-leave-to {
            opacity: 0;
        }


    }

    .stay-bottom-row {
        height: $registration-mobile-footer-height-closed;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 2;
        padding-right: map.get($spacers, 5);
        transition: padding-right $registration-transition-duration;

        .total {
            font-weight: $font-weight-bold;
        }

        .total::before {
            content: '';
            width: 0px;
            height: 1px;
            display: block;
            background: $body-color;
            transition: $registration-transition-duration $registration-timing-function;
        }

    }

    .stay-bottom-row-background {
        height: $registration-mobile-footer-stay-bottom-height;
        position: absolute;
        background: $white;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1;
    }

}

.mobile-footer.expanded {
    height: $registration-mobile-footer-max-height-expanded;

    .stay-top-row {
        .chevron {
            transform: rotate(180deg);
        }
    }

    .stay-bottom-row {
        padding-right: map.get($spacers, 4);


        .total::before {
            width: 100%;
        }

    }

}

.background-darken {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: $black;
    opacity: 0.5;
    z-index: 1;
}


.logo-mobile {
    height: 3.75rem;
    max-width: 4.375rem;
    min-width: 3.75rem;
    margin: map.get($spacers, 2) 0;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity $registration-transition-duration $registration-timing-function;
}

.fade-enter, .fade-leave-to {
    opacity: 0 !important;
}

</style>
